import { GenericError, IErrorDetails } from '@cian/peperrors/shared';

export class ChatOfferValidationError extends GenericError {
  public constructor(configuration: { domain: string; message: string; details?: IErrorDetails }) {
    super({
      ...configuration,
      type: 'ChatOfferValidationError',
    }) /* istanbul ignore next */;

    Object.setPrototypeOf(this, ChatOfferValidationError.prototype);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ChatOfferValidationError);
    } else {
      this.stack = new Error().stack;
    }
  }
}
